(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 989px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.headerDocumentTop = this.header.getBoundingClientRect().top + window.scrollY;

      this.setHeaderHeight();

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.setHeaderHeight);
        this.resizeObserver.observe(this.header);
      }

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      const headerBottom = Math.max(headerHeight, Math.floor(this.header.getBoundingClientRect().bottom));

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--header-bottom-position-desktop', `${headerBottom}px`);
      this.headerBounds = {
        top: this.headerDocumentTop,
        bottom: this.headerDocumentTop + headerHeight,
      };

      this.querySelectorAll('shopify-account').forEach((account) => {
        const accountBottom = Math.max(0, Math.round(account.getBoundingClientRect().bottom));
        account.style.setProperty('--account-dialog-top', `${accountBottom}px`);
      });
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.header.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close?.());
    }

    closeSearchModal() {
      this.header.querySelectorAll('details-modal').forEach((searchModal) => searchModal.close?.(false));
    }
  }

  const initializeOtsShopDrilldowns = (root = document) => {
    root.querySelectorAll?.('[data-ots-shop-drilldown]').forEach((drilldown) => {
      if (drilldown.dataset.otsDrilldownReady === 'true') return;

      const track = drilldown.querySelector('[data-ots-shop-track]');
      const rootScreen = drilldown.querySelector('[data-ots-shop-root]');
      const triggers = Array.from(drilldown.querySelectorAll('[data-ots-shop-open]'));
      const panels = Array.from(drilldown.querySelectorAll('[data-ots-shop-submenu]'));
      if (!track || !triggers.length || !panels.length) return;

      drilldown.dataset.otsDrilldownReady = 'true';
      let activeTrigger = null;
      let focusTimer = null;
      let suppressEscapeKeyup = false;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      const resetDrilldown = ({ focusTrigger = false, immediate = false } = {}) => {
        if (focusTimer) window.clearTimeout(focusTimer);
        const triggerToFocus = activeTrigger;
        triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
        activeTrigger = null;
        rootScreen?.removeAttribute('inert');
        rootScreen?.removeAttribute('aria-hidden');
        if (focusTrigger && triggerToFocus?.isConnected) triggerToFocus.focus({ preventScroll: true });
        panels.forEach((panel) => {
          panel.setAttribute('inert', '');
          panel.setAttribute('aria-hidden', 'true');
        });
        track.classList.remove('is-drilled-down');
        drilldown.removeAttribute('data-ots-shop-active');

        const finishReset = () => {
          panels.forEach((panel) => panel.setAttribute('hidden', ''));
        };

        if (immediate || prefersReducedMotion.matches) {
          finishReset();
          return;
        }

        focusTimer = window.setTimeout(finishReset, 230);
      };

      const openSubmenu = (trigger) => {
        const panel = drilldown.querySelector(`#${CSS.escape(trigger.dataset.otsShopOpen)}`);
        if (!panel) return;

        if (focusTimer) window.clearTimeout(focusTimer);
        panels.forEach((candidate) => {
          if (candidate === panel) {
            candidate.removeAttribute('hidden');
            candidate.removeAttribute('inert');
            candidate.removeAttribute('aria-hidden');
          } else {
            candidate.setAttribute('hidden', '');
            candidate.setAttribute('inert', '');
            candidate.setAttribute('aria-hidden', 'true');
          }
        });
        triggers.forEach((candidate) => candidate.setAttribute('aria-expanded', candidate === trigger ? 'true' : 'false'));
        activeTrigger = trigger;
        drilldown.dataset.otsShopActive = panel.id;
        panel.querySelector('[data-ots-shop-back]')?.focus({ preventScroll: true });
        rootScreen?.setAttribute('inert', '');
        rootScreen?.setAttribute('aria-hidden', 'true');

        window.requestAnimationFrame(() => {
          track.classList.add('is-drilled-down');
        });

      };

      triggers.forEach((trigger) => trigger.addEventListener('click', () => openSubmenu(trigger)));
      panels.forEach((panel) => {
        panel.querySelector('[data-ots-shop-back]')?.addEventListener('click', () => resetDrilldown({ focusTrigger: true }));
      });
      drilldown.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !activeTrigger) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressEscapeKeyup = true;
        resetDrilldown({ focusTrigger: true });
      });
      drilldown.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !suppressEscapeKeyup) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        suppressEscapeKeyup = false;
      });

      drilldown.otsResetDrilldown = resetDrilldown;
    });
  };

  const initializeOtsRetailDisclosures = (root = document) => {
    root.querySelectorAll?.('.ots-retail-menu').forEach((details) => {
      const summary = details.querySelector(':scope > summary');
      if (!summary) return;

      const syncExpandedState = () => summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      syncExpandedState();

      if (details.dataset.otsDisclosureReady === 'true') return;
      details.dataset.otsDisclosureReady = 'true';
      summary.setAttribute('role', 'button');
      details.addEventListener('toggle', () => {
        syncExpandedState();

        if (!details.open) details.querySelector('[data-ots-shop-drilldown]')?.otsResetDrilldown?.({ immediate: true });
      });
      details.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        if (event.target.closest('details[open]') !== details) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        details.removeAttribute('open');
        syncExpandedState();
        summary.focus();
      });
    });
  };

  const initializeOtsNavigation = (root = document) => {
    initializeOtsShopDrilldowns(root);
    initializeOtsRetailDisclosures(root);
  };

  const closeOtsHeaderOverlays = () => {
    let drawerWasOpen = false;

    document.querySelectorAll('.section-header').forEach((headerSection) => {
      headerSection.querySelectorAll('header-menu').forEach((menu) => menu.close?.());
      headerSection.querySelectorAll('details-modal').forEach((modal) => modal.close?.(false));

      const drawer = headerSection.querySelector('header-drawer');
      const drawerDetails = drawer?.querySelector(':scope > details');
      if (drawerDetails) {
        drawerWasOpen = drawerWasOpen || drawerDetails.open;
        drawerDetails.removeAttribute('open');
        drawerDetails.classList.remove('menu-opening');
        drawerDetails.querySelectorAll('details').forEach((details) => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        drawerDetails.querySelectorAll('summary').forEach((summary) => summary.setAttribute('aria-expanded', 'false'));
        drawerDetails.querySelectorAll('.submenu-open').forEach((submenu) => submenu.classList.remove('submenu-open'));
        if (drawer.onResize) window.removeEventListener('resize', drawer.onResize);
      }

      headerSection.classList.remove('menu-open');
    });

    if (drawerWasOpen) {
      document.body.classList.remove('overflow-hidden-mobile', 'overflow-hidden-tablet');
      removeTrapFocus();
    }
  };

  initializeOtsNavigation();
  if (document.documentElement.dataset.otsNavigationListeners !== 'true') {
    document.documentElement.dataset.otsNavigationListeners = 'true';
    window.matchMedia('(max-width: 989px)').addEventListener('change', closeOtsHeaderOverlays);
    document.addEventListener('shopify:section:load', (event) => initializeOtsNavigation(event.target));
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
